export const TimeFrameMap = {
  D: 'Daily',
  W: 'Weekly',
  M: 'Monthly'
}
